import { ENABLE_TREE_TABLE, MAPPER_ONLY_PROPAGATE_MAPPED_KEYS, PROXY_WRAPPED_APIS, SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA, } from './experimental-flags.js';
function experimentalFlagError(message) {
    return new Error(`[Experimental Flags Service]: ${message}`);
}
function createExperimentalFlagsService() {
    const flags = new Map([
        [ENABLE_TREE_TABLE.key, ENABLE_TREE_TABLE],
        [MAPPER_ONLY_PROPAGATE_MAPPED_KEYS.key, MAPPER_ONLY_PROPAGATE_MAPPED_KEYS],
        [PROXY_WRAPPED_APIS.key, PROXY_WRAPPED_APIS],
        [SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA.key, SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA],
    ]);
    let initialized = false;
    const getFlags = () => {
        return flags;
    };
    const getFlag = (flag) => {
        if (!flags.has(flag)) {
            throw experimentalFlagError(`Flag with key ${flag} does not exist.`);
        }
        return flags.get(flag);
    };
    const getEnableTreeTable = () => {
        return getFlag(ENABLE_TREE_TABLE.key).value;
    };
    const getMapperOnlyPropagateMappedKeys = () => {
        return getFlag(MAPPER_ONLY_PROPAGATE_MAPPED_KEYS.key).value;
    };
    const getProxyWrappedAPIs = () => {
        return getFlag(PROXY_WRAPPED_APIS.key).value;
    };
    const getSpreaderConsiderValueInsteadOfData = () => {
        return getFlag(SPREADER_CONSIDER_VALUE_INSTEAD_OF_DATA.key).value;
    };
    const hasBeenInitialized = () => {
        return initialized;
    };
    const initialize = (data) => {
        if (initialized) {
            return;
        }
        for (const [key, value] of Object.entries(data)) {
            if (flags.has(key)) {
                const existing = flags.get(key);
                flags.set(key, { ...existing, value });
            }
        }
        initialized = true;
    };
    return {
        getEnableTreeTable,
        getFlags,
        getMapperOnlyPropagateMappedKeys,
        getProxyWrappedAPIs,
        getSpreaderConsiderValueInsteadOfData,
        hasBeenInitialized,
        initialize,
    };
}
const ExperimentalFlagsService = createExperimentalFlagsService();
export { ExperimentalFlagsService, };
//# sourceMappingURL=experimental-flags-service.js.map